<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> LANÇAMENTO ESTOQUE</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-col class="py-0 justify-end text-end">
          <span class="text-h5">Documento:</span>
          <span class="text-h4"> {{ code }}</span>
        </v-col>
        <!-- <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn> -->
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="5">
              <v-row>
                <v-col cols="12" xs="12" md="10" v-if="isPageProvider">
                  Fornecedor:
                  <strong
                    >{{ this.companySessionSelected.code }} -
                    {{ this.companySessionSelected.name }}</strong
                  >
                </v-col>
                <v-col cols="12" xs="12" md="10" v-else>
                  <v-select
                    :items="providers"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    v-model="provider_id"
                    label="Fornecedor"
                    hide-details
                    :loading="loadingProvider"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <!-- <v-row>
                
              </v-row> -->
              <v-row>
                <v-col cols="12" xs="12" md="10">
                  <v-select
                    :items="settings"
                    :item-text="(item) => `${item.name}`"
                    item-value="id"
                    v-model="setting"
                    label="Operação"
                    hide-details
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" md="5">
              <v-textarea
                name="intput-7-1"
                label="Observação"
                class="text-field-uppercase"
                dense
                :height="100"
                hide-details
                outlined
                no-resize
                :value="observation"
                @input="(value) => (observation = value)"
              ></v-textarea>
            </v-col>
            <!-- <v-col
              cols="12"
              xs="12"
              md="4"
              class="d-flex justify-end align-end"
            >
              <v-btn color="blue darken-3" dark class="" @click="validate()">
                <v-icon left>mdi-send</v-icon> Fechar Documento
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col>
              <v-divider class="mx-4" inset></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="reference"
                label="Referência"
                dense
                outlined
                hide-details
                :loading="searchReference"
                @keydown.enter.prevent="searchProduct()"
                @keydown.tab.prevent="searchProduct()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                :value="`${product.company_code} ${product.reference} - ${product.name}`"
                label="Descrição Produto"
                disabled
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="materials"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="material"
                no-data-text="Preencha uma Referência"
                label="Material"
                hide-details
                dense
                outlined
                ref="materialRef"
                @change="handleChangeMaterial()"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="colors"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="color"
                label="Cor"
                no-data-text="Selecione um Material"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-btn
                color="green darken-3"
                dark
                class=""
                @click="addProduct()"
                :loading="loadingAddProduct"
              >
                <v-icon left>mdi-plus</v-icon> Incluir Novo Produto
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <span
                >Quantidade total de produtos lançados:
                <label class="font-weight-bold h3">{{
                  this.products.length
                }}</label></span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table fixed-header dense height="400px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="25%">Produto</th>
                      <th class="text-left" width="50%">Grade</th>
                      <th class="text-right" width="15%">Total</th>
                      <th class="text-right" width="10%">Deletar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in products"
                      :key="`${item.id}-${item.material.id}-${item.color.id}`"
                      style="height: 110px"
                    >
                      <td>
                        <v-row>
                          <v-col cols="4" class="py-1"> Referência: </v-col>
                          <v-col cols="8" class="font-weight-bold py-1"
                            >{{ item.company_code }} {{ item.reference }} -
                            {{ item.name }}</v-col
                          >
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="py-1"> Mateiral: </v-col>
                          <v-col cols="8" class="font-weight-bold py-1">
                            {{ item.material.code }} - {{ item.material.name }}
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="py-1"> Cor: </v-col>
                          <v-col cols="8" class="font-weight-bold py-1">
                            {{ item.color.code }} - {{ item.color.name }}
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="ma-3">
                            <div class="mb-0">
                              <table class="table-grid-cart">
                                <thead>
                                  <tr>
                                    <th
                                      v-for="size in item.sizes"
                                      :key="`${size.size}`"
                                      class="text-right"
                                    >
                                      {{ size.size }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-if="typeGrid === 'open'">
                                    <td
                                      v-for="size in item.sizes"
                                      :key="`${size.size}`"
                                      class="text-right"
                                    >
                                      <v-text-field
                                        v-model="size.quantity"
                                        outlined
                                        dense
                                        hide-details
                                        reverse
                                        @change="handleTotalProduct(item)"
                                      ></v-text-field>
                                    </td>
                                  </tr>
                                  <tr v-else>
                                    <td :colspan="item.sizes.length">
                                      <v-select
                                        :items="item.grids"
                                        :item-text="
                                          (item) =>
                                            `${item.id} - ${item.quantity
                                              .map((quantity) => quantity)
                                              .join(' ')}`
                                        "
                                        item-value="id"
                                        dense
                                        outlined
                                        hide-details
                                        :style="`width:${
                                          item.sizes.length * 84
                                        }px`"
                                        v-model="item.closeGridSelected"
                                      >
                                      </v-select>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <label class="font-weight-bold">{{ item.total }}</label>
                      </td>
                      <td class="text-right">
                        <v-btn
                          color="red darken-3"
                          dark
                          class=""
                          @click="deleteProduct(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              xs="12"
              md="12"
              class="d-flex justify-end align-end"
            >
              <v-btn
                v-if="id !== ''"
                color="red darken-3"
                dark
                outlined
                class="mr-4"
                @click="deleteDocument()"
              >
                <v-icon left>mdi-delete</v-icon> Deletar Documento
              </v-btn>
              <v-btn
                color="green darken-3"
                dark
                class="mr-4"
                @click="validate()"
              >
                <v-icon left>mdi-check</v-icon> Salvar Documento
              </v-btn>
              <v-btn
                v-if="id !== ''"
                color="blue darken-3"
                dark
                class=""
                @click="sendDocument()"
              >
                <v-icon left>mdi-send</v-icon> Fechar Documento
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogDelete" max-width="550px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Deletar esse Documento?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelDeleteDocument()"
            >Fechar</v-btn
          >
          <v-btn color="red darken-1" dark @click="confirmDeleteDocument()">
            <v-icon dark>mdi-delete</v-icon>
            Deletar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import * as HTTP from "@/api/requests/base";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import { settings as settingsStock } from "@/helpers/settings_express_stock";

export default {
  components: {},
  data: () => ({
    code: "00000000",
    id: "",
    loading: false,
    setting: "",
    companies: [],
    company: "",
    observation: "",
    searchReference: false,
    loadingAddProduct: false,
    loadingProvider: false,
    reference: "",
    material: "",
    color: "",
    materials: [],
    colors: [],
    provider_id: "",
    providers: [],
    isPageProvider: false,
    products: [],
    companySessionSelected: {
      code: "",
      name: "",
      id: "",
    },
    companySelected: "",
    product: {
      name: "",
      reference: "",
      code: "",
      company_code: "",
    },
    settings: [],
    typeGrid: "open",
    standardGrids: [],
    valid: true,
    lazy: false,
    user_id: "",
    dialogDelete: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.settings = settingsStock;
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
        this.companySelected = this.companySessionSelected.id;
        this.provider_id = this.companySessionSelected.id;
        this.isPageProvider = true;
      }
      if (session.user !== "") {
        this.user_id = session.user.id;
      }

      this.initialize();
    } else {
      this.initialize();
    }
    // this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getStock(this.$route.params.id);
      } else if (this.user_id !== "") {
        this.getStockByUser();
      }
      if (!this.isPageProvider) {
        this.getProviders();
      }
    },
    goToBackList() {
      this.$router.push({ name: "SettingsOrderExpress" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.id !== "") {
          this.updateAdjustmentStock(true);
        } else {
          this.saveAdjustmentStock();
        }
      }
    },
    async sendDocument() {
      const data = {
        products: this.products.map((item) => ({
          product_id: item.product_id,
          color_id: item.color.id,
          material_id: item.material.id,
          sizes: item.sizes,
        })),
        provider_id: this.provider_id,
        operation: this.setting,
        user_id: this.user_id,
        observation: this.observation,
        status: "sending",
      };
      this.loading = true;
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}express/stock/${this.id}`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res.status === 200) {
          alert(
            `Documento ${this.formaterCode(this.code)} Enviado com sucesso`
          );
          this.$router.push({ path: "/express/lancamento-estoque" });
          location.reload();
        }
      } catch (error) {
        alert(
          "Não foi possível enviar o documento, tente novamente mais tarde"
        );
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async addProduct() {
      if (this.material === "") {
        alert("Selecione um material para poder continuar");
        return false;
      }
      if (this.color === "") {
        alert("Selecione uma cor para poder continuar");
        return false;
      }

      this.product.product_id = this.product.id;

      this.product.material = this.materials.find(
        (item) => item.id === this.material
      );
      this.product.color = this.colors.find((item) => item.id === this.color);
      this.product.total = 0;
      this.getGridProduct();
    },
    async getGridProduct() {
      this.loadingAddProduct = true;
      try {
        let res = await fetch(
          `${URL}product/product-sizes/${this.product.grid_id}`
        );
        res = await res.json();
        this.product.sizes = res.sizes.map((item) => ({
          size: item,
          quantity: 0,
        }));
        if (this.typeGrid === "closed") {
          const grids = this.standardGrids.filter(
            (item) => item.grid_id === this.product.grid_id
          );
          if (grids.length === 0) {
            alert(
              "Não existe grade fechada/padrão cadastrada para grade desse produto"
            );
            return false;
          }
          this.product.grids = grids;
          this.product.closeGridSelected = "";
        }
        console.log(this.product);
        this.products.push(this.product);
        this.saveDocumentAddProduct();
        this.resetProduct();
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingAddProduct = false;
      }
    },
    resetProduct() {
      this.product = {
        reference: "",
        code: "",
        company_code: "",
        name: "",
      };
      this.material = "";
      this.materials = [];
      this.color = "";
      this.colors = [];
      this.reference = "";
    },
    saveDocumentAddProduct() {
      if (this.products.length > 0) {
        if (this.id === "") {
          this.saveAdjustmentStock();
        } else {
          this.updateAdjustmentStock(false);
        }
      }
    },
    async searchProduct() {
      if (this.searchReference) {
        return false;
      }

      console.log(this.setting);
      const settingSelected = this.settings.find(
        (item) => item.id === this.setting
      );
      if (settingSelected !== undefined) {
        this.typeGrid = !settingSelected.grid ? "closed" : "open";
        if (settingSelected.grid === false && this.standardGrids.length === 0) {
          this.getStandardGrids();
        }
      }

      this.searchReference = true;
      this.product = {
        reference: "",
        code: "",
        company_code: "",
        name: "",
      };
      const body = {
        type: "change-collection",
        reference: this.reference,
        company_id: this.provider_id,
      };
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}express/search-product`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(body),
        });
        res = await res.json();
        if (res.product) {
          this.product = res.product;
          this.materials = this.product.attributes.map((item) => ({
            id: item.material_id,
            name: item.material_name,
            code: item.material_code,
          }));
          if (this.materials.length === 1) {
            this.material = this.materials[0].id;
            this.handleChangeMaterial();
          }
          console.log();
          this.$refs.materialRef.focus();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.searchReference = false;
      }
    },
    handleChangeMaterial() {
      this.colors = this.product.attributes
        .filter((item) => item.material_id === this.material)
        .map((item) => ({
          id: item.color_id,
          name: item.color_name,
          code: item.color_code,
        }));
      if (this.colors.length === 1) {
        this.color = this.colors[0].id;
      }
    },
    handleTotalProduct(product) {
      let index = this.products.findIndex(
        (item) =>
          item.id === product.id &&
          item.color.id === product.color.id &&
          item.material.id === product.material.id
      );
      console.log(product.sizes);
      product.total = product.sizes.reduce(
        (a, b) => a + (isNaN(parseInt(b.quantity)) ? 0 : parseInt(b.quantity)),
        0
      );

      this.products.splice(index, 1, product);
    },
    async deleteProduct(product) {
      const data = {
        order_express_stock_id: this.id,
        product_id: product.product_id,
        material_id: product.material.id,
        color_id: product.color.id,
      };
      this.loading = true;

      const myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}express/stock/delete-product`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res.status === 200) {
          let response = await res.json();
          this.products = response.products;
        }
      } catch (error) {
        alert("Problema ao deletar o produto, tente novamente mais tarde");
        console.log(error);
      } finally {
        this.loading = false;
      }
      console.log(product);
    },
    async getProviders() {
      this.loadingProvider = true;
      try {
        let res = await CompanyAPI.getAll("?type=for");
        this.providers = res.sort((a, b) => (a.code < b.code ? -1 : 1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingProvider = false;
      }
    },
    async getStandardGrids() {
      try {
        let res = await fetch(`${URL}standard-grid`);
        this.standardGrids = await res.json();
      } catch (error) {
        this.standardGrids = [];
        console.log(error);
      }
    },
    async saveAdjustmentStock() {
      const data = {
        products: this.products.map((item) => ({
          product_id: item.id,
          color_id: item.color.id,
          material_id: item.material.id,
          sizes: item.sizes,
        })),
        user_id: this.user_id,
        provider_id: this.provider_id,
        operation: this.setting,
        observation: this.observation,
      };
      this.loading = true;
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}express/stock`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        res = await res.json();
        console.log(res);
        this.id = res.orderExpress.id;
        this.code = this.formaterCode(res.orderExpress.code);
        this.$router.replace({ path: `/express/lancamento-estoque/${res.id}` });
        // console.log(await res.json());
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async updateAdjustmentStock(validated) {
      const data = {
        products: this.products.map((item) => ({
          product_id: item.product_id,
          color_id: item.color.id,
          material_id: item.material.id,
          sizes: item.sizes,
        })),
        provider_id: this.provider_id,
        operation: this.setting,
        user_id: this.user_id,
        observation: this.observation,
        status: "pending",
      };
      this.loading = true;
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}express/stock/${this.id}`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res.status === 200) {
          if (validated) {
            alert("Documento atualizado com sucesso");
          }
        }
        // res = await res.json();
        // console.log(res);
        // console.log(await res.json());
      } catch (error) {
        alert(
          "Não foi possível atualizar o documento, tente novamente mais tarde"
        );
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getStock(id) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}express/stock/${id}`);
        let response = await res.json();
        if (res.status !== 200) {
          this.$router.replace({ path: "/express/lancamento-estoque" });
          // alert(response.message);
        } else {
          this.id = response.id;
          this.observation = response.observation;
          this.provider_id = response.provider_id;
          this.setting = response.operation;
          this.code = this.formaterCode(response.code);
          this.products = response.products;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getStockByUser() {
      this.loading = true;
      try {
        let res = await fetch(
          `${URL}express/stock/get-by-user/${this.user_id}`
        );
        res = await res.json();
        if (typeof res.id !== "undefined") {
          this.$router.push({ path: `/express/lancamento-estoque/${res.id}` });
          this.id = res.id;
          this.observation = res.observation;
          this.provider_id = res.provider_id;
          this.setting = res.operation;
          this.code = this.formaterCode(res.code);
          this.products = res.products;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    formaterCode(code) {
      return code.toString().padStart(7, 0);
    },
    deleteDocument() {
      this.dialogDelete = true;
    },
    async cancelDeleteDocument() {
      this.dialogDelete = false;
    },
    async confirmDeleteDocument() {
      const myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}express/stock/${this.id}`, {
          method: "DELETE",
          headers: myHeaders,
        });
        res = await res.json();
        console.log(res);
        this.dialogDelete = false;
        alert("Documento deletado com sucesso");
        this.id = "";
        this.code = "0000000";
        this.$router.push({ path: "/express/lancamento-estoque" });
        location.reload();
      } catch (error) {
        console.log(error);
        alert(
          "Houve um problema ao deletar o documento, tente novamente mais tarde"
        );
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
<style scoped>
.document-number {
  font-size: 18px;
  font-weight: bold;
}

.table-grid-cart {
  border-collapse: collapse;
}

.table-grid-cart > thead > tr > th,
.table-grid-cart > tbody > tr > td {
  width: 70px;
  padding: 6px;
  border: 1px solid black;
}

.table-grid-cart > tbody > tr > td {
  background-color: white !important;
}
</style>
